import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { classesURL } from "../../Hooks/URL";
import { userContext } from "../../Contexts/userContext";
import useFetchWhen from "../../Hooks/useFetchWhen";
import useFetch from "../../Hooks/useFetch";
import AddReport from "../../Templates/Reports/AddReport/AddReport";

function AddReportPage({ Edit = false }) {
  const { contextData, setContextData } = useContext(userContext);
  const navigate = useNavigate();
  let { id, report_id } = useParams();
  const url = `${classesURL}/${id}`;
  const { data, loading, error } = useFetch(url);
  const [Class, setClass] = useState("");

  useEffect(() => {
    if (!loading && !error && data) {
      setClass(data?.data);
    }
  }, [data, loading, error]);

  useEffect(() => {
    setContextData({ ...contextData, page: "programs", data: "" });
  }, []);

  return <AddReport Edit={Edit} Class={Class} loading={loading} url={url} />;
}

export default AddReportPage;
